import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: 16,
  md: 24,
  lg: 40,
};

export function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <Spin
      indicator={<LoadingOutlined style={{ fontSize: sizeMap[size] }} spin />}
      className={className}
    />
  );
}
